import { globalNavHeight } from 'nav-meta/global-nav-height';
export const critStyles = ['body, html { margin: 0; padding: 0}', `#hs-nav-v4 nav, #hs-nav-v4 div, #hs-nav-v4 span, #hs-nav-v4 ul, #hs-nav-v4 li, #hs-nav-v4 a, #hs-nav-v4 svg, #hs-nav-v4 img, #hs-nav-v4 title, #hs-nav-v4 input {
  -webkit-font-smoothing: antialiased;
  font-family: var(--uicomponents-font-family, "Lexend Deca", Helvetica, Arial, sans-serif);
  font-size: 13px;
  font-weight: 500;
  color: rgb(51, 71, 91);
  line-height: 1.5rem;
  margin: 0;
  padding: 0;
  border: 0;
  vertical-align: baseline;
  transition: none 0s ease 0s;
  text-shadow: transparent 0 0 1px;
  box-sizing: border-box;
}`, `#hs-nav-v4 .nav-links {
  max-width: 100%;
  height: ${globalNavHeight};
}`, `#hs-nav-v4 .nav-links ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}`, `#hs-nav-v4 .primary-links>li {
  display: inline-block;
  vertical-align: middle;
  position: relative;
}`, `#hs-nav-v4 .primary-link {
  padding: 0 8px;
  line-height: ${globalNavHeight};
  font-weight: 500;
  cursor: pointer;
}`, `#hs-nav-v4 .logo {
  width: 40px;
  height: 40px;
  box-sizing: content-box;
  padding: 0;
  vertical-align: middle;
  display: inline;
}`, `#hs-nav-v4 .arrow-down-icon {
  height: 4px;
  width: 10px;
  vertical-align: middle;
}`, `#hs-nav-v4 .expansion {
  z-index: 9999;
  display: none;
  padding: 1em 0;
  position: absolute;
  white-space: nowrap;
}`, `#hs-nav-v4 .secondary-nav {
  background-color: rgb(37, 51, 66);
  top: ${globalNavHeight};
  left: 0;
  min-width: 190px;
}`, `#hs-nav-v4 .arrow-right-icon {
  width: 4px;
  position: absolute;
  right: 18px;
  top: 0;
  bottom: 0;
  margin: auto;
}`, `#hs-nav-v4 .tertiary-nav {
  left: 100%;
  min-width: 170px;
  background-color: rgb(51, 71, 91);
  min-height: 100%;
  top: 0;
  box-sizing: border-box;
}`, `#hs-nav-v4 .name-change-tooltip {
  max-width: 250px;
  width: 100%;
}`, `#hs-nav-v4 .name-change-tooltip-inner {
  background-color: rgb(81, 111, 144);
  margin: 5px 11px 0 8px;
  border-radius: 3px;
  position: relative;
}`, `#hs-nav-v4 .name-change-tooltip-text {
  box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 8px;
  background-color: rgb(37, 51, 66) !important;
  line-height: 2;
  max-width: 100%;
  padding: 10px;
  text-decoration: none;
  overflow-wrap: break-word;
  white-space: normal;
  font-size: 11px;
  color: rgb(255, 255, 255) !important;
  display: inline-block;
}
`, `
#hs-nav-v4 .name-change-tooltip-text svg {
  margin-bottom: -3px !important;
  margin-top: 4px;
  margin-right: 1px;
}
`, `#hs-nav-v4 .navtools {
  display: flex;
  padding-right: 0;
  height: ${globalNavHeight};
  flex-grow: 1;
  justify-content: flex-end;
}`, `#hs-nav-v4 .hidden {
  display: none;
}`, `#hs-nav-v4 .settings a {
  padding: 0px 5px;
  background: transparent;
  border: transparent solid 0;
}`, `.space-sword--editor #placeholder-vertical-nav {
  display: none
}`, `.space-sword--editor .page, .space-sword--editor .app {
  width: auto;
  margin-left: 0;
}`];
export const hublessStyles = [`
  #placeholder-vertical-nav {
    display: none;
  }
  `, `
  .app, .page {
    width: auto !important;
    margin-left: auto !important;
  }
`];
export const CRITICAL_CSS_ID = 'hs-nav-critical-css';
export default function loadCriticalCSS(args) {
  const newStyles = document.createElement('style');
  newStyles.id = CRITICAL_CSS_ID;
  newStyles.type = 'text/css';
  document.head.appendChild(newStyles);
  const criticalCSS = [...critStyles];
  if (args && args.isHubless) {
    criticalCSS.push(...hublessStyles);
  }
  criticalCSS.forEach(ruleSet => {
    newStyles.sheet.insertRule(ruleSet, newStyles.sheet.cssRules.length);
  });
}